export default __webpack_public_path__ + "static/media/shareEnable.ff5a7e5d.svg";